import { nextTick } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Hotjar only sees the initial URL in an SPA; tell it about later navigations once the new view has rendered.
// window.hj is undefined until the preload spinner is gone, so earlier navigations are skipped.
router.afterEach((to, _from, failure) => {
    // afterEach also fires for cancelled/duplicate navigations; only report ones that actually changed the view.
    if (failure || !window.hj) return;
    nextTick(() => window.hj?.('stateChange', to.fullPath));
});

export default router;
